
//////////////////////////////////////////////////////  GLOBAL VARIABLES ////////////////////////////////////////////////////

let langSelected;

let styleDivForLangSel = document.createElement('style');

let langSelector = document.querySelector('.languages');

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////// FUNCTIONS DEFINITIONS //////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////// GRAB THE RELEVANT HTML PAGE ELEMENTS /////////////////////////////////////////////////////

function grabHtmlContentForLangTranslate() {
/* let langSelector = document.querySelector('.languages');
//console.log(langSelector);

let els2BeTranslated = document.querySelectorAll('[lang]');
//console.log(els2BeTranslated);

let langButtonIt = document.getElementById('italian');
//console.log(langButtonIt);

let legendButtonIt = document.querySelector('label:has(#italian)');
//console.log(legendButtonIt);

let langButtonEn = document.getElementById('english');
//console.log(langButtonEn);

let legendButtonEn = document.querySelector('label[for=english]');
//console.log(legendButtonEn);
*/

return {
	headEl: document.querySelector('head'),
	els2BeTranslated: document.querySelectorAll('[lang]'),
	langButtonIt: document.getElementById('italian'),
	legendButtonIt: document.querySelector('label:has(#italian)'),
	langButtonEn: document.getElementById('english'),
}
}
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



/////////////////////////// CHANGE LANGUAGE IN HTML ELEMENTS WITH TEXT BASED ON LANG SELECTION //////////////////////////////
function replaceLang(ev) {
	
	const {headEl, els2BeTranslated, langButtonIt, legendButtonIt, langButtonEn} = grabHtmlContentForLangTranslate();
	console.log(els2BeTranslated);
	localStorage.setItem("langSelected", ev.target.value);

if (ev.target.value ==='italian')
{
//	langSelected = "italian";
	
	for (const el of els2BeTranslated)
	{
		if (el.getAttribute('lang') === 'en' || el.getAttribute('lang') === 'en_flex')
		{el.style.display = 'none';}
		
		else if (el.getAttribute('lang') === 'it' || el.getAttribute('lang') === 'it_flex')
		{//el.style.display = 'initial';
		el.style.display = 'block';
		el.style.animationName = "none";
		//el.style.backgroundColor = "initial"; 
		el.style.backgroundColor = "revert-layer";
		
		if (el.tagName === 'SPAN')
		{el.style.display = "inline";}
		
		if (el.tagName === 'INPUT')
		{el.style.backgroundColor ="#E37383";
		el.style.display = "inline";}
		
		if (el.getAttribute('lang') === 'it_flex')
		{el.style.display = 'flex';}
		
		}
	
	}
	
	styleDivForLangSel.innerHTML = 'input[value=italian] {checked: "true";} \n input[value=english] {checked: "false";}';
	console.log(styleDivForLangSel.innerHTML);
//	langButtonEn.style.checked = "false";
	/* legendButtonEn.style.setProperty('outline', 'initial');
	legendButtonEn.style.setProperty('outlineOffset', 'initial');
	legendButtonEn.style.setProperty('borderImage', 'initial'); */
} 

else if (ev.target.value ==='english')
{
	
	for (const el of els2BeTranslated)
	{
		if (el.getAttribute('lang') === 'it' || el.getAttribute('lang') === 'it_flex')
		{el.style.display = 'none';}
		
		else if (el.getAttribute('lang') === 'en' || el.getAttribute('lang') === 'en_flex')
		{//el.style.display = 'initial';
	el.style.display = 'block';
	el.style.animationName = "none";
	//el.style.backgroundColor = "initial";
	el.style.backgroundColor = "revert-layer";
	
	if (el.tagName === 'SPAN')
	{el.style.display = "inline";}
	
	if (el.tagName === 'INPUT')
	{el.style.backgroundColor ="#E37383";
	el.style.display = "inline";}
	
	if (el.getAttribute('lang') === 'en_flex')
	{el.style.display = 'flex';}	

	}
	
	//console.log(el.getElementType); 
	}
	
	styleDivForLangSel.innerHTML = 'input[value=italian] {checked: "false";} \n input[value=english] {checked: "true";}';
//	langButtonIt.style.checked = "false";
	/* legendButtonIt.style.setProperty('outline', 'initial');
	legendButtonIt.style.setProperty('outlineOffset', 'initial');
	legendButtonIt.style.setProperty('borderImage', 'initial'); */

} 

console.log(ev.target.value);

}
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



////////////////////// MANAGE LANGUAGE IN NEW PAGE BASED ON LANGUAGE SELECTED IN PREVIOUS PAGES///////////////

function setLang(SeldLang) {
	
const {headEl, els2BeTranslated, langButtonIt, legendButtonIt, langButtonEn} = grabHtmlContentForLangTranslate();

	headEl.appendChild(styleDivForLangSel);

if (SeldLang ==='italian')
{
	
	for (const el of els2BeTranslated)
	{
		if (el.getAttribute('lang') === 'en' || el.getAttribute('lang') === 'en_flex')
		{el.style.display = 'none';}
		
		else if (el.getAttribute('lang') === 'it' || el.getAttribute('lang') === 'it_flex')
		{//el.style.display = 'initial';
	el.style.display = 'block';
	el.style.animationName = "none";
	//el.style.backgroundColor = "initial";
	el.style.backgroundColor = "revert-layer";
	
	if (el.tagName === 'SPAN')
	{el.style.display = "inline";}
	
	if (el.tagName === 'INPUT')
	{el.style.backgroundColor = "#E37383";
	el.style.display = "inline";}
	
	if (el.getAttribute('lang') === 'it_flex')
	{el.style.display = 'flex';}

		}
	}
} 

else if (SeldLang ==='english')
{
	
	for (const el of els2BeTranslated)
	{
		if (el.getAttribute('lang') === 'it' || el.getAttribute('lang') === 'it_flex')
		{el.style.display = 'none';}
		
		else if (el.getAttribute('lang') === 'en' || el.getAttribute('lang') === 'en_flex')
		{//el.style.display = 'initial';
	el.style.display = 'block';
	el.style.animationName = "none";
	//el.style.backgroundColor = "initial";
	el.style.backgroundColor = "revert-layer";
	
	if (el.tagName === 'SPAN')
	{el.style.display = "inline";}
	
	if (el.tagName === 'INPUT')
	{el.style.backgroundColor ="#E37383";
	el.style.display = "inline";}
	
	if (el.getAttribute('lang') === 'en_flex')
	{
	el.style.display = 'flex';
	}
}
	
	// console.log(el.getAttribute('lang'));
	console.log(el.getElementType); 
	}
}

		if (SeldLang==='italian')
		{
			styleDivForLangSel.innerHTML = `.languages label[for="italian"] {
	outline: 0.1vmin solid black;\n outline-offset: -0.1vmin;
	box-shadow: inset 0vmin 0vmin 0.5vmin 0vmin;
	border-image: linear-gradient(to left, rgba(0,0,0,0.8), transparent 10% 90%, rgba(0,0,0,0.8)) 0 fill/0/0;
	border-image: linear-gradient(to left, rgba(0,0,0,0.8), rgba(211,211,211,0.5) 10% 90%, rgba(0,0,0,0.8)) 0 fill/0/0;
	border-image: linear-gradient(to left, rgba(211,211,211,0.2) 0% 100%) 0 fill/0/0;}\n`;
		}
		
		else 
		{
			styleDivForLangSel.innerHTML = `.languages label[for="english"] {
	outline: 0.1vmin solid black; \n outline-offset: -0.1vmin;
	box-shadow: inset 0vmin 0vmin 0.5vmin 0vmin;
	border-image: linear-gradient(to left, rgba(0,0,0,0.8), transparent 10% 90%, rgba(0,0,0,0.8)) 0 fill/0/0;
	border-image: linear-gradient(to left, rgba(0,0,0,0.8), rgba(211,211,211,0.5) 10% 90%, rgba(0,0,0,0.8)) 0 fill/0/0;
	border-image: linear-gradient(to left, rgba(211,211,211,0.2) 0% 100%) 0 fill/0/0;}\n`;
		} 

}
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////	EVENT HANDLERS /////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


/////////////////////////////////////////////////////////// HANDLER FOR LANGUAGE SELECTOR BUTTON PRESSED EVENT /////////////////////////////

langSelector.addEventListener('change', replaceLang)

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


/////////////////////////////////////////////////////////// HANDLER FOR LOAD PAGE EVENT /////////////////////////////

window.addEventListener('load', function () {
	
	let currentLang = localStorage.getItem("langSelected");
	
	if (!currentLang)
	{
		currentLang = 'italian';
	}
	
	setLang(currentLang);

} )

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////